import { createFileRoute, useParams } from "@tanstack/react-router";
import { requireFeature } from "@/lib/feature-gate";
import { TaskDetailPage } from "@/components/task/TaskDetailPage";

export const Route = createFileRoute("/admin/_layout/tasks_/$id")({
  beforeLoad: () => requireFeature("tasks"),
  component: AdminTaskDetail,
});

function AdminTaskDetail() {
  const { id } = useParams({ from: "/admin/_layout/tasks_/$id" });
  return (
    <TaskDetailPage
      taskId={Number(id)}
      isAdmin={true}
      isCrm={false}
      backTo="/admin/tasks"
      
    />
  );
}
